import { BUSINESS, NAV_LINKS } from "@/config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E0D8] bg-bone">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif-display text-3xl text-text-main">{BUSINESS.name}</div>
            <p className="overline mt-2">{BUSINESS.tagline}</p>
            <p className="text-text-muted mt-6 max-w-sm leading-relaxed">
              Precision assembly of premade saunas — indoor and outdoor — throughout Columbus, Ohio and Central Ohio.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="font-accent text-sm text-text-main hover:text-cedar"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-4">Contact</p>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  data-testid="footer-email"
                  className="font-accent text-sm text-text-main hover:text-cedar"
                >
                  {BUSINESS.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${BUSINESS.phone}`}
                  data-testid="footer-phone"
                  className="font-accent text-sm text-text-main hover:text-cedar"
                >
                  {BUSINESS.phone}
                </a>
              </li>
              <li className="font-accent text-sm text-text-muted">{BUSINESS.serviceArea}</li>
              <li className="font-accent text-sm text-text-muted">{BUSINESS.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#E5E0D8] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-accent text-xs text-text-muted">
            © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved. {BUSINESS.established}.
          </p>
          <p className="font-accent text-xs text-text-muted">Central Ohio</p>
        </div>
      </div>
    </footer>
  );
}
